let getLocale = () => "es-ES";
let getCurrency = () => "EUR";

export function configureFormatters({ localeGetter, currencyGetter }) {
  getLocale = localeGetter;
  getCurrency = currencyGetter;
}

export function formatCurrency(amount, decimals = 0, currency = false) {
    const locale = getLocale() || 'es-ES';
    const curr = currency || getCurrency();
    return new Intl.NumberFormat(locale, { style: "currency", currency: curr, currencyDisplay: "symbol", minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
}
